import ScrollingTitle from './ScrollingTitle'
export default ScrollingTitle
